import { ReactComponent as TriangleDown } from './svg/triangleDown.svg'

export default TriangleDown
